function formatDuration(durationInSeconds) {
  if (!durationInSeconds) return null
  const date = new Date(null)
  date.setSeconds(durationInSeconds)
  return date.toISOString().substr(11, 8)
}

export default formatDuration
